[
  {
    "year": 2023,
    "limit": 160200,
    "taxRate": 0.062
  },
  {
    "year": 2024,
    "limit": 168600,
    "taxRate": 0.062
  },
  {
    "year": 2025,
    "limit": 176100,
    "taxRate": 0.062
  }
]
